document.addEventListener('turbolinks:load', () => {
  if(document.querySelector('body').classList.contains('home')) {
    // get the height of the header
    const headerHeight = document.querySelector('header').offsetHeight;
    // add headerHeight to hero padding-top
    document.querySelector('.hero').style.paddingTop = `${headerHeight * 1.5}px`;
    // add headerHeight * -1 to hero margin-top
    document.querySelector('.hero').style.marginTop = `${headerHeight * -1}px`;
  }
})